import { createBaseClient } from './factory';
import { createWithAuthPlugin } from '../plugins/with-auth';
import { createContentTypeJsonPlugin } from '../plugins/content-type-json';
import { createWithGlueResourcePlugin } from '../plugins/with-glue-resource';
import { GlueRequestInitExtension, InternalRequestInit } from '@/src/lib/http/types';
import { createWithGuestHeaderClientPlugin } from '@/src/lib/http/plugins/with-guest-header.client';
import { createWithGlueUrlPlugin } from '@/src/lib/http/plugins/with-glue-url';
import { handleFetchResponse } from '@/src/lib/http/utils/handle-fetch-response';
import { createWithIfMatchPlugin } from '@/src/lib/http/plugins/with-if-match.server';
import { createWithLocaleHeaderPluginClient } from '@/src/lib/http/plugins/with-locale.client';

export type GlueClient = ReturnType<typeof createGlueClient>;

export function createGlueClient() {
  return createBaseClient<InternalRequestInit & GlueRequestInitExtension>(
    {
      plugins: [
        createWithGlueUrlPlugin(),
        createWithAuthPlugin(),
        createWithGlueResourcePlugin(),
        createContentTypeJsonPlugin(),
        createWithLocaleHeaderPluginClient(),
        createWithGuestHeaderClientPlugin(),
        createWithIfMatchPlugin(),
      ],
    },
    handleFetchResponse,
  );
}
